import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {TableObject} from '../../models/tableObject';
import {CACHE_KEY} from './interceptors/cache-header.interceptor';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) {
  }

  /* Get */
  get<T>(reqUrl: string) {
    return this.http.get<T>(reqUrl);
  }

  getTableRecords<T>(reqUrl: string) {
    return this.http.get<TableObject<T>>(reqUrl);
  }

  getTableRecordNoCache<T>(reqUrl: string) {
    return this.http.get<T>(reqUrl, {
      headers: {
        [CACHE_KEY]: '1'
      }
    });
  }

  getTableRecordsNoCache<T>(reqUrl: string) {
    return this.http.get<TableObject<T>>(reqUrl, {
      headers: {
        [CACHE_KEY]: '1'
      }
    });
  }

  getTableRecordsNoCacheBasic<T>(reqUrl: string) {
    return this.http.get<T>(reqUrl, {
      headers: {
        [CACHE_KEY]: '1'
      }
    });
  }

  getProductsRecordsNoCacheBasic<T>(reqUrl: string) {
    return this.http.get<T[]>(reqUrl, {
      headers: {
        [CACHE_KEY]: '1'
      }
    });
  }

  /* Post */
  post<T>(reqUrl: string, toAdd: T) {
    return this.http.post(reqUrl, toAdd);
  }

  /* Patch */
  patch<T>(reqUrl: string, toUpdate: T) {
    return this.http.patch<T>(reqUrl, toUpdate);
  }

  /* Put */
  put<T>(reqUrl: string, toUpdate: T) {
    return this.http.put<T>(reqUrl, toUpdate);
  }

  /* Delete */
  delete(reqUrl: string, id: number) {
    return this.http.delete(reqUrl + '/' + id);
  }

  deleteIsin(reqUrl: string, isin: string) {
    return this.http.delete(reqUrl + '/' + isin);
  }

  deleteNoParameters(reqUrl: string) {
    return this.http.delete(reqUrl);
  }

  getMatrice<T>(reqUrl: string) {
    return this.http.get(reqUrl);
  }

  getSubMatrice<T>(reqUrl: string, sottostantecode: string) {
    return this.http.get(reqUrl + '/' + sottostantecode);

  }
}
